(function () {
  function initialize(root) {
    root.querySelectorAll('.bl-home').forEach(function (hero) {
      if (hero.dataset.videoReady === 'true') return;
      hero.dataset.videoReady = 'true';

      var video = hero.querySelector('.bl-home__video');
      var mobile = window.matchMedia('(max-width: 749px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function updateVideo() {
        if (reducedMotion.matches) {
          video.pause();
          hero.classList.remove('bl-home--playing');
          video.removeAttribute('src');
          video.load();
          return;
        }

        var nextSource = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (video.getAttribute('src') !== nextSource) {
          hero.classList.remove('bl-home--playing');
          video.src = nextSource;
          video.load();
        }

        var playing = video.play();
        if (playing && typeof playing.catch === 'function') {
          playing.catch(function () { hero.classList.remove('bl-home--playing'); });
        }
      }

      video.addEventListener('playing', function () { hero.classList.add('bl-home--playing'); });
      video.addEventListener('error', function () { hero.classList.remove('bl-home--playing'); });
      mobile.addEventListener('change', updateVideo);
      reducedMotion.addEventListener('change', updateVideo);
      updateVideo();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

